import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {ReceiptInfoTypeVo} from '../../common/shared/api/nicolas/vo/enums/ReceiptInfoTypeVo.enum';

/**
 * 영수증 정보 변경
 *
 * Origin: pageNicolasApi.updateReceiptInfo
 * API: POST /api/v1/store/receipt/update
 */
export async function postStoreReceiptUpdate(
  params: {
    receiptInfoType: ReceiptInfoTypeVo;
    receiptInfo: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/receipt/update',
    {
      method: 'POST',
      data: {
        receipt_info_type: params.receiptInfoType,
        receipt_info: params.receiptInfo,
      },
    },
    options
  );
  return response.data;
}
